import { orderService } from '@/services/order'
import i18n from '@/i18n'

const callValidateZipCodeApi = (country, zipCode) => {
  return orderService.validateZipCode(country, zipCode)
}

export const validateZipCode = (country) => ({
  async validator(_, value) {
    if (!value) {
      return
    }
    const response = await callValidateZipCodeApi(country, value)
    if (response === true) {
      return
    }

    throw new Error(i18n.t('myProfile.form.validateMessages.invalidZip'))
  },
})

export const isFormDirty = (initialValues, changedValues) => {
  if (!initialValues) {
    return true
  }

  return (
    Object.keys(changedValues).filter((key) => {
      const initial = initialValues[key]
      const changed = changedValues[key]

      if ([key] in initialValues) {
        return initial !== changed
      }

      return !!changed
    }).length > 0
  )
}
